import {contactPropertiesOperation} from '../../../util/uiconstants';

export default (entities, {userIds, tagModified, operation}) => {
	const newStateEntities = entities.map((entity, idx) => {
		return {
			...entity,
			contacts: entity.contacts.map((contact) => {
				if (userIds.has(contact.userId)) {
					if (operation === contactPropertiesOperation.addTag) {
						if (!contact.tags.some((tag) => tag.id === tagModified.id)) {
							return {...contact, tags: [...contact.tags, tagModified]};
						} else {
							return {...contact};
						}
					} else {
						const newTags = contact.tags.filter((tag) => tag.id !== tagModified.id);
						return {...contact, tags: [...newTags]};
					}
				} else {
					return {...contact};
				}
			})
		};
	});

	return [...newStateEntities];
};
